import React from 'react';
import {withTranslation} from 'react-i18next';
import {Table} from 'reactstrap';
import Api from "../services/Api";
import {NotificationManager} from "../components/common/react-notifications";
import Switch from "react-switch";
import ModalManager from "../components/modal/ModalManager";
import moment from "moment/moment";
import {i18nizeDate} from "../helpers/Utils";

class TokenSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      settings: props.settings,
    };
  }

  onChangeStatus = (type, name, value) => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Confirm Change Status'),
      body: t('Are you sure you want change {{type}} {{name}} status to {{value}}?', {
        type: t(type),
        name: t(name),
        value: value ? t("enabled") : t("disabled"),
      }),
      buttons: [
        {
          color: 'primary',
          onClick: async () => {
            await this.changeStatus(type, name, value);
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Yes'),
        },
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('No'),
        },
      ],
    });
  };

  changeStatus = async (type, name, value) => {
    const {settings} = this.state;
    const {t, token} = this.props;
    const formData = new FormData();
    const newSettings = {
      ...settings,
      [type]: {
        ...settings[type],
        [name]: value,
      }
    };
    this.setState({settings: newSettings});
    formData.append("setting", JSON.stringify(newSettings));
    try {
      await Api.invoke(
        'PUT',
        `/v2/admin-ui/tokens/${token}`,
        formData,
      );
      NotificationManager.success(t('Token {{symbol}} updated successfully', {symbol: token}), t('Message'));
    } catch (e) {
      this.setState({settings});
      console.log("error: ", e);
    }
  };

  onChangeUserBuyOrderStatus = async enabled => {
    const {t, listedAt, releasedAt} = this.props;
    if (enabled && !listedAt) {
      const diff = moment(releasedAt).diff(moment(), 'minutes');
      if (diff > 1) {
        ModalManager.open({
          isOpen: true,
          title: t('Confirm List'),
          body: t('The estimated date for listing this token is {{date}} Are you sure you want to list now?', {
            date: i18nizeDate(releasedAt),
          }),
          buttons: [
            {
              color: 'primary',
              onClick: async () => {
                await this.changeStatus('user', 'buyOrder', enabled);
                ModalManager.close({
                  isOpen: false
                });
              },
              text: t('Yes'),
            },
            {
              color: 'grey',
              onClick: () => {
                ModalManager.close({
                  isOpen: false
                });
              },
              text: t('No'),
            },
          ],
        });
        return;
      }
    }
    await this.onChangeStatus('user', 'buyOrder', enabled);
  };

  render() {
    const {t} = this.props;
    const {settings} = this.state;
    if (settings) {
      const {user, bot} = settings;
      return(
        <div className="table-row-sub py-2">
          <Table bordered responsive>
            <tbody>
            <tr>
              <td style={{width: 150}}>{t('Action')}</td>
              <td>{t('User Side')}</td>
              <td>{t('Bot Side')}</td>
            </tr>
              <tr>
                <td style={{width: 150}} className="text-info">{t('Place Buy Order')}</td>
                <td>
                  <Switch
                    className="ltr mt-1"
                    onChange={this.onChangeUserBuyOrderStatus}
                    checked={user.buyOrder}
                    height={24}
                    width={45}
                  />
                </td>
                <td>
                  <Switch
                    className="ltr mt-1"
                    onChange={async enabled => {await this.onChangeStatus('bot', 'buyOrder', enabled);}}
                    checked={bot.buyOrder}
                    height={24}
                    width={45}
                  />
                </td>
              </tr>
              <tr>
                <td style={{width: 150}} className="text-info">{t('Place Sell Order')}</td>
                <td>
                  <Switch
                    className="ltr mt-1"
                    onChange={async enabled => {await this.onChangeStatus('user', 'sellOrder', enabled);}}
                    checked={user.sellOrder}
                    height={24}
                    width={45}
                  />
                </td>
                <td>
                  <Switch
                    className="ltr mt-1"
                    onChange={async enabled => {await this.onChangeStatus('bot', 'sellOrder', enabled);}}
                    checked={bot.sellOrder}
                    height={24}
                    width={45}
                  />
                </td>
              </tr>
              <tr>
                <td style={{width: 150}} className="text-info">{t('Deposit')}</td>
                <td>
                  <Switch
                    className="ltr mt-1"
                    onChange={async enabled => {await this.onChangeStatus('user', 'canDeposit', enabled);}}
                    checked={user.canDeposit}
                    height={24}
                    width={45}
                  />
                </td>
                <td>
                  <Switch
                    className="ltr mt-1"
                    onChange={async enabled => {await this.onChangeStatus('bot', 'canDeposit', enabled);}}
                    checked={bot.canDeposit}
                    height={24}
                    width={45}
                  />
                </td>
              </tr>
              <tr>
                <td style={{width: 150}} className="text-info">{t('Withdraw')}</td>
                <td>
                  <Switch
                    className="ltr mt-1"
                    onChange={async enabled => {await this.onChangeStatus('user', 'canWithdraw', enabled);}}
                    checked={user.canWithdraw}
                    height={24}
                    width={45}
                  />
                </td>
                <td>
                  <Switch
                    className="ltr mt-1"
                    onChange={async enabled => {await this.onChangeStatus('bot', 'canWithdraw', enabled);}}
                    checked={bot.canWithdraw}
                    height={24}
                    width={45}
                  />
                </td>
              </tr>
              <tr>
                <td style={{width: 150}} className="text-info">{t('Convert Assets')}</td>
                <td>
                  <Switch
                    className="ltr mt-1"
                    onChange={async enabled => {await this.onChangeStatus('user', 'changeAssets', enabled);}}
                    checked={user.changeAssets}
                    height={24}
                    width={45}
                  />
                </td>
                <td>
                  <Switch
                    className="ltr mt-1"
                    onChange={async enabled => {await this.onChangeStatus('bot', 'changeAssets', enabled);}}
                    checked={bot.changeAssets}
                    height={24}
                    width={45}
                  />
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      );
    }
    return null;
  }
}

export default withTranslation()(TokenSettings);
